export * from 'utils/bolt/showtimes.js';

import hooks from 'utils/hooks';
import { arrayUnique } from 'utils/utils';

/*
5af344ca-fb3a-42c3-9f33-8cce8f9fa821 2D-4DX-Q&A
8d2e2db6-ee43-4eff-8a03-73b52cfcf6aa 2D-SCREENX-Q&A
e24f5a76-6efb-4c1c-9ddb-856992deb53e 2D-ATMOS-Q&A
34f7033f-855b-492a-934e-deceb5e0c5b2 2D-DOLBY-Q&A (edited) 
*/

const allQAFormats = ['2D-4DX-Q&A', '2D-SCREENX-Q&A', '2D-ATMOS-Q&A', '2D-DOLBY-Q&A'];

function isFormat(format, formatToCheck) {
	if (!format || !formatToCheck) return false;
	return format.toLowerCase().includes(formatToCheck.toLowerCase());
}

hooks.register('showtimes.request.filters.preprocess', filters => {
	if (filters?.format?.some(f => f === 'Q&A')) {
		// Add all QA formats
		filters.format = arrayUnique([...filters.format, ...allQAFormats]);
	}
	if (filters?.format?.some(f => isFormat(f, '4dx'))) {
		filters.format = arrayUnique([...filters.format, '2D-4DX-Q&A']);
	}
	if (filters?.format?.some(f => isFormat(f, 'screenx'))) {
		filters.format = arrayUnique([...filters.format, '2D-SCREENX-Q&A']);
	}
	if (filters?.format?.some(f => isFormat(f, 'atmos'))) {
		filters.format = arrayUnique([...filters.format, '2D-ATMOS-Q&A']);
	}
	if (filters?.format?.some(f => isFormat(f, 'dolby cinema') || isFormat(f, '2d-dolby'))) {
		filters.format = arrayUnique([...filters.format, '2D-DOLBY-Q&A']);
	}
	return filters;

});

hooks.register('filters.formats.expand', filters => {
	const filtersWIthoutQ = filters.filter(f => !allQAFormats.includes(f));
	return filtersWIthoutQ;
});